import React from 'react';
import {Filter, ReferenceInput, SelectInput, TextInput, useTranslate} from 'react-admin';

export const FunctionFilter = (props) => {
    const translate = useTranslate();

    const translateWithCount = (key, count = 1) => {
        const translationKey = `resources.functions.fields.${key}`;
        return count === 1 ? translate(`${translationKey}.one`) : translate(`${translationKey}.other`);
    };

    return (
        <Filter {...props}>
            <ReferenceInput
                label={translateWithCount('type')}
                source="type_id"
                reference="types"
                filter={{"aspect_id": "function"}}
                allowEmpty
            >
                <SelectInput
                    optionText="name"
                    label={translateWithCount('type')}
                    emptyText={translate('resources.functions.selectEmpty.type')}
                />
            </ReferenceInput>
            <ReferenceInput
                label={translateWithCount('scope')}
                source="scope_id"
                reference="scopes"
                filter={{"aspect_id": "function"}}
                allowEmpty
            >
                <SelectInput
                    optionText="name"
                    label={translateWithCount('scope')}
                    emptyText={translate('resources.functions.selectEmpty.scope')}
                />
            </ReferenceInput>
            <TextInput label={translate('resources.functions.fields.fulltext')} source="query"/>
        </Filter>
    );
};
